import * as React from 'react'
import dynamic from 'next/dynamic'

import { useSiteConfig } from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { TagsProps, TextStyling } from '@thg-commerce/gravity-patterns'

import { useProductPage } from '../../context/ProductPageContext'

const Container = styled.div`
  margin-top: ${spacing(1)};
`

const ProductTags = dynamic<TagsProps>(
  import('@thg-commerce/gravity-patterns/Tags').then((mod) => mod.Tags),
)
const StyledProductTags = styled(ProductTags)<{
  textStyle?: TextStyling
}>`
  display: flex;
  flex-wrap: wrap;
  ${(props) =>
    Text(
      props.textStyle ? props.textStyle?.entry : 'bodyText',
      props.textStyle ? props.textStyle?.style : 'default',
    )};
`

export const ProductTagsRenderer = () => {
  const { product } = useProductPage()
  const { disableProductTagsOnPDP } = useSiteConfig()

  const theme = useTheme()

  if ((product?.tags || []).length === 0 || disableProductTagsOnPDP) {
    return null
  }

  return (
    <Container>
      <StyledProductTags
        textStyle={theme?.pageTheme?.productSummary?.tags?.textStyle}
        tags={product?.tags || []}
        colors={{
          tagColor: theme.pageTheme?.productSummary?.tags?.colors?.tag,
          textColor: theme.pageTheme?.productSummary?.tags?.colors?.text,
        }}
        padding={theme.pageTheme?.productSummary?.tags?.padding}
        borderRadius={theme.pageTheme?.productSummary?.tags?.borderRadius}
      />
    </Container>
  )
}
